import type { KeyValue } from 'ngrx-forms';

import type { NGRXProgressiveFormsActions } from '../actions';
import { MarkAsUnvisitedAction } from '../actions';
import type { ProgressiveFormGroupState } from '../state';

export function markAsUnvisitedReducer<TValue extends KeyValue>(
  state: ProgressiveFormGroupState<TValue>,
  action: NGRXProgressiveFormsActions
): ProgressiveFormGroupState<TValue> {
  if (action.type !== MarkAsUnvisitedAction.TYPE) {
    return state;
  }

  if (action.stepId !== state.id) {
    return state;
  }

  if (state.isUnvisited) {
    return state;
  }

  return {
    ...state,
    isVisited: false,
    isUnvisited: true,
  };
}
